export function round2(number) {
	return Math.round(number * 100) / 100;
}

export function getMonthlyPayment(payment, monthlyFees) {
	return payment + monthlyFees;
}

export function getPercent(credit, number, tax, monthlyPayment) {
	let count = 0;
	let minRpsn = 0;
	let maxRpsn = 100;
	let sum = 0;
	let rpsn = 5;

	while (Math.abs(credit - sum) > 0.1 && count < 50) {
		count++;

		rpsn = (maxRpsn + minRpsn) / 2;

		sum = tax;
		for (var i = 1; i <= number; i++) {
			sum = sum + monthlyPayment / Math.pow(1 + rpsn, i);
		}

		if (sum > credit) {
			minRpsn = rpsn;
		} else {
			maxRpsn = rpsn;
		}
	}

	return round2((Math.pow(1 + rpsn, 12) - 1) * 100);
}

export function getTotal(monthlyPayment, tax, number) {
	return monthlyPayment * number + tax;
}

export default function({ credit, payment, number, tax, monthlyFees }) {
	const monthlyPayment = getMonthlyPayment(payment, monthlyFees);
	const percent = getPercent(credit, number, tax, monthlyPayment);
	const total = getTotal(monthlyPayment, tax, number);

	return {
		percent,
		total,
	};
}
